import { IconProps } from '../../../lib/types';

const Times: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <svg
      tabIndex={onClick ? 0 : -1}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};
export default Times;
